module.exports = __webpack_public_path__ + "img/2.d147c1db.png";